import React from 'react';

const ExceededMessage = function ExceededMessage(props) {
  const { message } = props;

  return (
    <>
      {message}
    </>
  );
};

export default ExceededMessage;
